import React from 'react';
import CustomVerticalStepper from '../../Components/CustomVerticalStepper';
import ProductSteps from './ProductSteps';
import reqProvider from '../../util/requests/reqProvider';
import { useSelector } from 'react-redux';
import { RootState } from '../../globalStore/store'

const ProductForm = ({ mode }: { mode: string }) => {
  const [activeStep, setActiveStep] = React.useState<number>(0);
  const product = useSelector((state: RootState) => state.product);
  const handleNext = () => {
    setActiveStep(prevState => prevState + 1);
  };
  const handleBack = () => {
    setActiveStep(prevState => prevState - 1);
  }

  const handleSave = () => {
    const payload = {
      ...product.details,
      units: product.packaging.units,
      posSetId: Number(localStorage.getItem('productPosSetId')),
      tags: []
    };

    if (mode === 'create') {
      reqProvider.post('/product', payload).then((response) => {
        console.log('siker')
      }).catch((error) => {
        console.log(error)
      });
    } else {
      reqProvider.put(`/product/${product.details.id}`, payload).then((response) => {
        console.log('siker')
      }).catch((error) => {
        console.log(error)
      });
    }
  };

  return (
    <CustomVerticalStepper title={mode === 'create' ? 'Új termék hozzáadása' : 'Módosítás'} steps={ProductSteps(mode)} activeStep={activeStep} onNext={handleNext} onBack={handleBack} save={handleSave}/>
  );
}

export default ProductForm